import { render, staticRenderFns } from "./RoleMultiselect.vue?vue&type=template&id=e580770c&"
import script from "./RoleMultiselect.vue?vue&type=script&lang=ts&"
export * from "./RoleMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports